import { __decorate, __metadata } from "tslib";
import { injectable } from "inversify";
import { GlobalApplicationContext } from "@fastoche/ui-core/application/GlobalApplicationContext";
import { TrackingEventDispatcher } from "./TrackingEventDispatcher";
import { CommonTrackingEvents } from "../model/CommonTrackingEvents";
import { Logger } from "@leavy/logger";
let NavigationTracker = class NavigationTracker {
    constructor(dispatcher, logger) {
        this.dispatcher = dispatcher;
        this.logger = logger;
        this.isTracking = false;
    }
    async onPageView(to, from) {
        if (to.fullPath == from.fullPath) {
            return;
        }
        const event = new CommonTrackingEvents.PageViewEvent({
            url: document.location.origin + to.path,
            path: to.path,
            referrer: document.referrer,
            name: to.name ?? undefined,
            category: to.meta?.category,
        });
        try {
            await this.dispatcher.dispatch(event);
        }
        catch (e) {
            this.logger.warn("Error happened while tracking page navigation", e);
        }
    }
    startTracking() {
        if (this.isTracking)
            return;
        GlobalApplicationContext.default.router.afterEach((to, from) => {
            void this.onPageView(to, from);
        });
        this.isTracking = true;
    }
};
NavigationTracker = __decorate([
    injectable(),
    __metadata("design:paramtypes", [TrackingEventDispatcher,
        Logger])
], NavigationTracker);
export { NavigationTracker };
//# sourceMappingURL=NavigationTracker.js.map